import { Box, Card, LoadingOverlay, Modal, SimpleGrid, Text } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import BadgeStatus from '../../elements/BadgeStatus';
import Button from '../../elements/Button';
import GridCell from '../../elements/GridCell';
import ImageRotator from '../../elements/ImageRotator';
import IdentityPhotoForm from '../../forms/IdentityPhotoForm/IdentityPhotoForm';
import IcAgent from '../../icons/IcAgent';
import IconEditImage from '../../icons/IconEditImage';
import IconKey from '../../icons/IconKey';
import styles from './styles.scoped.css';
import IconSecure from '../../icons/IconSecure';
import IcSecure from '../../icons/IcSecure';
import Tooltip from '../../elements/Tooltip';
import Divider from '../../elements/Divider';

export default function DetailInfoMerchant({
  data,
  handleResendAccount,
  handleSuspend,
  timer,
  handleUpload,
  modalUpdaload,
  setModalUpload,
  loading,
  // dataDetailUser = {},
  // onClickHistoryAgent = () => {},
  // setModalAgent = () => {}
}) {

  const renderManageAccess = () => {
    return (
      <div className={styles.cardAgent}>
        <div className={styles.cardHeader}>
          <IcSecure />
          <h4>Kelola Akses Masuk Pangkalan</h4>
        </div>
        <div className={styles.buttonContainer}>
          <div className={styles.cardAgent}>
            <Text fw={500} mb={6} size={'md'}>Blokir PIN Pangkalan</Text>
            <Text fw={400} mb={16}>Pangkalan akan dipaksa untuk mengatur ulang PIN mandiri.</Text>
            {data.isPinBlocked ?
              <Tooltip content="Sudah blokir PIN. Aktif kembali setelah pangkalan selesai atur ulang PIN." position="top">
                <Button
                  className={styles.btnEdit}
                  disabled={data.isPinBlocked}
                  onClick={handleSuspend}
                  outlined
                  style={'blue'}
                >
                  <IconSecure className={styles.iconWhite} /> Blokir PIN Pangkalan
                </Button>
              </Tooltip>
              :
              <Button
                className={styles.btnEdit}
                disabled={data.isPinBlocked}
                onClick={handleSuspend}
                outlined
                style={'blue'}
              >
                <IconSecure className={styles.iconWhite} /> Blokir PIN Pangkalan
              </Button>
            }
          </div>
          <div className={styles.cardAgent}>
            <Text fw={500} mb={6} size={'md'}>Kirim Ulang Akun</Text>
            <Text fw={400} mb={16}>Pangkalan akan dikirimkan email untuk mengatur ulang PIN.</Text>
            <Button
              className={styles.btnEdit}
              onClick={handleResendAccount}
              outlined
              style={'blue'}
            >
              <IconKey className={styles.iconWhite} /> Kirim Ulang Akun {`${timer || ''}`}
            </Button>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Box pos="relative">
      <LoadingOverlay overlayProps={{ radius: 'sm', blur: 2 }} visible={loading} zIndex={99} />
      <Card mb={24} radius="md" withBorder>
        <Card.Section inheritPadding py="xs">
          <p className={styles.sectionTitle}>Data Pangkalan LPG 3 Kg</p>
        </Card.Section>
        <SimpleGrid breakpoints={[
          { minWidth: 'sm', cols: 1 },
          { minWidth: 'md', cols: 1 },
          { minWidth: 1200, cols: 2 },
        ]}>
          <div className={styles.cells}>
            <GridCell data={data.registrationDate} label="Tanggal Registrasi" />
            <GridCell data={data.registrationTime} label="Jam Registrasi" />
            <GridCell data={data?.registrationId} label="ID Pangkalan" />
            <GridCell data={data.midMap} label="MID" />
            <GridCell data={data.midLA} label="MID LinkAja" />
            <GridCell data={data.ownerName} label="Nama Pemilik" />
            <GridCell data={data.nationalityId} label="No. KTP Pemilik" />
            <GridCell data={data.phoneNumber} label="No. Ponsel Pemilik" />
            <GridCell
              data={data.storePhoneNumber}
              label="No. Telepon Pangkalan LPG 3 Kg"
            />
            <GridCell className={styles.nowrap} data={data.email} label="Email Pemilik" />
          </div>
          {/* {data?.isIdentityImageExist && */}
          <div>
            <ImageRotator
              customeComponent={
                data.identityImage &&
                <Button
                  className={styles.btnEdit}
                  disabled={false}
                  onClick={() => setModalUpload(true)}
                  style={'blue'}><IconEditImage fill="#0F6EB5" /> Ganti Foto KTP</Button>
              }
              image={data.identityImage ? data.identityImage : ''}
              title="Foto KTP" />
          </div>
          {/* } */}
        </SimpleGrid>
        <div className={styles.cardAgent}>
          <div className={styles.cardHeader}>
            <IcAgent />
            <h4>Data Agen</h4>
            {data?.agen?.status !== 'registrasi' &&
              <BadgeStatus label={data?.agen?.status} />}
          </div>
          <div className={styles.cells}>
            <GridCell data={data?.agen?.id} label="ID Agen" />
            <GridCell data={data.agen?.name} label="Nama Agen" />
            {data?.agen?.status === 'sementara' &&
              <GridCell data={`${data.agen?.startDate} - ${data.agen?.endDate}`} key={0} label="Tanggal" />
            }
            {data?.agen?.status === 'permanen' &&
              <GridCell data={`${data.agen?.startDate}`} key={1} label="Tanggal" />
            }
          </div>
        </div>
        <Card.Section inheritPadding mt="md" py="xs">
          <p className={styles.sectionTitle}>Alamat Pangkalan LPG 3 Kg</p>
        </Card.Section>
        <SimpleGrid breakpoints={[
          { minWidth: 'sm', cols: 1 },
          { minWidth: 'md', cols: 1 },
          { minWidth: 1200, cols: 2 },
        ]}>
          <div className={styles.cells}>
            <GridCell data={data.provinceName} label="Provinsi" />
            <GridCell data={data.cityName} label="Kota/Kabupaten" />
            <GridCell data={data.districtName} label="Kecamatan" />
            <GridCell data={data.villageName} label="Kelurahan" />
          </div>
          <div className={styles.cells}>
            <GridCell data={data.zipcode} label="Kode Pos" />
            <GridCell data={data.street} label="Alamat" />
          </div>
        </SimpleGrid>
        <Card.Section inheritPadding mt="md" py="xs">
          <p className={styles.sectionTitle}>Rekening Bank</p>
        </Card.Section>
        <SimpleGrid breakpoints={[
          { minWidth: 'sm', cols: 1 },
          { minWidth: 'md', cols: 1 },
          { minWidth: 1200, cols: 2 },
        ]}>
          <div className={styles.cells}>
            <GridCell data={data.bank?.bankName} label="Nama Bank" />
            <GridCell data={data.bank?.accountNumber} label="Nomor Rekening" />
            <GridCell
              data={data.bank?.accountName}
              label="Nama Pemilik Rekening"
            />
          </div>
        </SimpleGrid>
        {renderManageAccess()}
        <Modal centered onClose={() => setModalUpload(false)} opened={modalUpdaload} size={'lg'} withCloseButton={false}>
          <div className={styles.modal} >
            <h5> Ganti Foto KTP</h5>
            <Divider />
          </div>
          <IdentityPhotoForm
            handleClose={() => setModalUpload(false)}
            handleSubmit={handleUpload} />
        </Modal>
      </Card>
    </Box>
  );
}

DetailInfoMerchant.propTypes = {
  data: PropTypes.shape({
    userId: PropTypes.string,
    registrationId: PropTypes.string,
    registrationDate: PropTypes.string,
    registrationTime: PropTypes.string,
    agen: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      status: PropTypes.string
    }),
    wave: PropTypes.number,
    nationalityId: PropTypes.string,
    identityImage: PropTypes.string,
    isIdentityImageExist: PropTypes.bool,
    midMap: PropTypes.string,
    midLA: PropTypes.string,
    storeName: PropTypes.string,
    ownerName: PropTypes.string,
    phoneNumber: PropTypes.string,
    storePhoneNumber: PropTypes.string,
    email: PropTypes.string,
    zipcode: PropTypes.string,
    street: PropTypes.string,
    coordinate: PropTypes.string,
    regionalId: PropTypes.string,
    regionalName: PropTypes.string,
    provinceId: PropTypes.string,
    provinceName: PropTypes.string,
    cityId: PropTypes.string,
    cityName: PropTypes.string,
    districtId: PropTypes.string,
    districtName: PropTypes.string,
    villageId: PropTypes.string,
    villageName: PropTypes.string,
    bank: PropTypes.shape({
      bankName: PropTypes.string,
      accountNumber: PropTypes.string,
      accountName: PropTypes.string
    }),
    isSuspend: PropTypes.bool,
    isPinBlocked: PropTypes.bool.isRequired,
    suspendHistory: PropTypes.array,
    reviewer: PropTypes.string,
  }).isRequired,
  dataDetailUser: PropTypes.object,
  handleEdit: PropTypes.func.isRequired,
  handleResendAccount: PropTypes.func.isRequired,
  handleSuspend: PropTypes.func.isRequired,
  handleUpload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  modalUpdaload: PropTypes.bool,
  onClickHistoryAgent: PropTypes.func,
  setModalAgent: PropTypes.func,
  setModalUpload: PropTypes.func,
  timer: PropTypes.string,
};
